import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import CaseList, { DispatchProps, OwnProps, StateProps } from './CaseList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getCaseNoPrincipals, getCaseNoPrincipalsCsv } from 'src/store/actions/caseNoPrincipal-actions';
import { selectNameStudents } from 'src/store/selectors/students-selectors';
import { selectNameVendors } from 'src/store/selectors/vendors-selectors';
import { selectNameDistricts } from 'src/store/selectors/districts-selectors';
import { getStudentsSmall } from 'src/store/actions/student-actions';
import { getVendorsSmall } from 'src/store/actions/vendor-actions';
import { getDistrictsSmall } from 'src/store/actions/district-actions';
import { selectNameProviders } from '../../../../../store/selectors/providers-selectors';
import { getProvidersSmall } from '../../../../../store/actions/provider-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.casesNoPrincipal.data,
        students: selectNameStudents(state),
        districts: selectNameDistricts(state),
        vendors: selectNameVendors(state),
        providers: selectNameProviders(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getCaseNoPrincipals(params)),
        getDataCsv: (params: QueryParams) => dispatch(getCaseNoPrincipalsCsv(params)),
        getStudents: (params: QueryParams) => dispatch(getStudentsSmall(params)),
        getVendors: (params: QueryParams) => dispatch(getVendorsSmall(params)),
        getDistricts: (params: QueryParams) => dispatch(getDistrictsSmall(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
    };
}

const CaseListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(CaseList);

export default CaseListScreen;
